import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';

const getCustomerDetail = (state: AppState) => state.contactsAndOrganizations.customers.customerDetail;

export const customerEmployeeSelector = createSelector(getCustomerDetail, state => state.employees.employees);
export const customerBonusContactCountSelector = createSelector(
    getCustomerDetail,
    state => state.employees.bonusContactCount
);
